import { BannerImages, ImageCenter, ImageLeft, ImageRight, Wrapper } from './BlogBannerShards'

const BlogBanner = () => {
  return (
    <Wrapper>
      <BannerImages>
        <ImageLeft src='/assets/weekly/left.svg' />
        <ImageCenter src='/assets/weekly/center.svg' />
        <ImageRight src='/assets/weekly/right.svg' />
      </BannerImages>
    </Wrapper>
  )
}

export default BlogBanner
